module.exports = __webpack_public_path__ + "media/images/star-solid-d231312360688b46426d7e6bf1dee907.png";